// extracted by mini-css-extract-plugin
export default {"plugin_glossary":"PluginGlossary_plugin_glossary__aMbua"};